import { render, staticRenderFns } from "./OpenVSClickVSBounce.vue?vue&type=template&id=85a1470c&scoped=true&"
import script from "./OpenVSClickVSBounce.vue?vue&type=script&lang=js&"
export * from "./OpenVSClickVSBounce.vue?vue&type=script&lang=js&"
import style0 from "./OpenVSClickVSBounce.vue?vue&type=style&index=0&id=85a1470c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a1470c",
  null
  
)

export default component.exports